import { cn } from '@/utils';
type HeroTitleProps = {
  title: string;
  className?: string;
};
export const HeroTitle = ({
  title,
  className
}: HeroTitleProps) => {
  return <h1 className={cn('text-default', 'tablet-sm:text-heading-xl-extrabold text-heading-lg-extrabold', className)} data-sentry-component="HeroTitle" data-sentry-source-file="HeroTitle.tsx">
      {title}
    </h1>;
};